export type NotifySeverity = 'error' | 'warning' | 'info' | 'success';

/**
 * Dispatches a global notification event that GlobalSnackbar listens for.
 * Safe to call from non-React modules (service files, interceptors, etc.).
 */
export function notify(
  message: string,
  severity: NotifySeverity = 'error',
): void {
  window.dispatchEvent(
    new CustomEvent('app:notify', { detail: { message, severity } }),
  );
}
